import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const arielTrades: SeasonTrades[] = [
  {
    season: "2012/13",
    allTrades: [
      {
        otherTeam: manager.chauncey,
        sentAway: "Serge Ibaka",
        gotInReturn: "Kobe Bryant",
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Robin Lopez",
        gotInReturn: "Jeff Green",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Bradley Beal",
        gotInReturn: "Al Jefferson",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Roy Hibbert and Courtney Lee",
        gotInReturn: "Zach Randolph and Larry Sanders",
      },
      {
        otherTeam: manager.chauncey,
        sentAway: "Zach Randolph",
        gotInReturn: "Tim Duncan",
      },
    ],
  },
  {
    season: "2014/15",
    allTrades: [
      {
        otherTeam: manager.oded,
        sentAway: "Al Jefferson",
        gotInReturn: "Dirk Nowitzki",
      },
    ],
  },
  {
    season: "2015/16",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Monta Ellis",
        gotInReturn: "Chandler Parsons",
      },
      {
        otherTeam: manager.mati,
        sentAway: "Kevin Love",
        gotInReturn: "Derrick Favors",
      },
      {
        otherTeam: manager.idan,
        sentAway: "Derrick Favors and PJ Tucker",
        gotInReturn: "Marcin Gortat and Mike Conley",
        amongBestTrades: true
      },
    ],
  },
  {
    season: "2016/17",
    allTrades: [
      {
        otherTeam: manager.zeev,
        sentAway: "CJ McCollum and top 3 protected 1st round pick in 2018/19 draft",
        gotInReturn: "Kemba Walker"
      }
    ]
  },
  {
    season: "2017/18",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Taurean Prince and Carmelo Anthony",
        gotInReturn: "John Wall"
      },
      {
        otherTeam: manager.idan,
        sentAway: "Lou Williams",
        gotInReturn: "Khris Middleton"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Khris Middleton", 
        gotInReturn: "Kyle Kuzma"
      }
    ]
  },
  {
    season: "2018/19",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Joel Embiid and Kyle Lowry",
        gotInReturn: "Giannis Antetokounmpo and Chris Paul",
        amongBestTrades: true
      },
      
    ]
  },
  {
    season: "2019/20",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Chris Paul",
        gotInReturn: "Kevin Love and Ricky Rubio"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Draymond Green",
        gotInReturn: "Kristaps Porzingis",
        amongBestTrades: true
      }
    ]
  },
  {
    season: "2020/21",
    allTrades: [
      {
        otherTeam: manager.yevgeny,
        sentAway: "Kristaps Porzingis and DeAaron Fox",
        gotInReturn: "Clint Capela",
        amongBestTrades: true
      }
    ]
  },
  { season: "2021/22", allTrades: [] },
  {
    season: "2022/23",
    allTrades: [
      {
        otherTeam: manager.mati,
        sentAway: "Mitchell Robinson and Buddy Hield",
        gotInReturn: "Rudy Gobert and Qunetin Grimes"
      },
      {
        otherTeam: manager.kobe,
        sentAway: "Giannis Antetokounmpo",
        gotInReturn: "Shai Gilgeous-Alexander",
        amongBestTrades: true
      }
    ]
  },
  { season: "2023/24", allTrades: [] }
];
